import {Injector, NgModule} from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from "@ngx-translate/core";
import { CookieDisclaimerComponent} from "./cookie-disclaimer";
import { CmsModule } from '@signature-it/ngx-generic/components/cms';
import {CookieDisclaimerTypeModuleGeneric} from "./cookie-disclaimer-type/cookie-disclaimer-type.module";
import {CookieDisclaimerBtnModuleGeneric} from "./cookie-disclaimer-btn/cookie-disclaimer-btn.module";
import {createCustomElement} from "@angular/elements";

@NgModule({
    imports: [
        CommonModule,
        TranslateModule,
        CookieDisclaimerBtnModuleGeneric,
        CookieDisclaimerTypeModuleGeneric,
        CmsModule
    ],
    declarations: [CookieDisclaimerComponent],
    exports: [CookieDisclaimerComponent],
})

export class CookieDisclaimerModule {
    constructor(private injector: Injector) {
        const CookieDisclaimerComp = createCustomElement(CookieDisclaimerComponent, {injector});
        !customElements.get('ngx-cookie-disclaimer') && customElements.define('ngx-cookie-disclaimer', CookieDisclaimerComp);
    }
}
